import { useEffect, useRef } from "react";
import { Heart, ArrowDown } from "lucide-react";
import { Link } from "react-router-dom";

const VIDEO_URL = "https://customer-assets.emergentagent.com/job_tyss-redesigned/artifacts/1e9a1m2e_6940173-uhd_2560_1440_25fps.mp4";

export default function HeroSection() {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) videoRef.current.play().catch(() => {});
  }, []);

  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="hero-video-container">
        <video ref={videoRef} autoPlay muted loop playsInline preload="auto" className="w-full h-full object-cover" aria-hidden="true">
          <source src={VIDEO_URL} type="video/mp4" />
        </video>
        <div className="hero-overlay" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full pt-28 pb-16">
        <div className="max-w-3xl">
          <p
            data-testid="hero-label"
            className="text-xs sm:text-sm font-sans tracking-[0.25em] uppercase font-semibold text-white/80 mb-6"
            style={{ animation: "fade-in-up 0.8s ease-out 0.1s forwards", opacity: 0 }}
          >
            <span className="inline-block w-10 h-[2px] bg-[#0E8DB5] mr-3 align-middle" />
            Trauma Youth Support Services
          </p>

          <h1
            data-testid="hero-headline"
            className="text-5xl sm:text-6xl lg:text-8xl font-serif font-bold tracking-tight leading-[1.02] text-white mb-8"
            style={{ textShadow: "0 3px 30px rgba(0,0,0,0.35)", animation: "fade-in-up 1s ease-out 0.2s forwards", opacity: 0 }}
          >
            Healing Starts Here
            <br />
            <span className="gradient-text" style={{ WebkitTextFillColor: "transparent" }}>
              for Families in Crisis
            </span>
          </h1>

          <p
            data-testid="hero-subheadline"
            className="text-lg sm:text-xl font-sans font-medium leading-relaxed text-white max-w-xl mb-10"
            style={{ textShadow: "0 1px 8px rgba(0,0,0,0.3)", animation: "fade-in-up 1s ease-out 0.4s forwards", opacity: 0 }}
          >
            When a child is in crisis, caregivers are often left overwhelmed, scared, and without answers. TYSS steps in when families need it most.
          </p>

          <div className="flex flex-wrap gap-4" style={{ animation: "fade-in-up 1s ease-out 0.6s forwards", opacity: 0 }}>
            <a
              data-testid="hero-donate-button"
              href="https://20d0a0a2-9bc3-4878-a451-dbaa4c9318b7.paylinks.godaddy.com/bfd32eeb-318a-425f-b9fb-26a"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-pill btn-primary text-base px-8 py-4 no-underline shadow-lg shadow-[#0E8DB5]/30"
            >
              <Heart className="w-5 h-5" />
              Donate Now
            </a>
            <Link
              data-testid="hero-get-support-button"
              to="/caregiver-resources"
              className="btn-pill btn-outline-light text-base px-8 py-4 no-underline"
            >
              Get Support
            </Link>
          </div>
        </div>
      </div>

      <button
        data-testid="hero-scroll-down"
        onClick={() => document.querySelector("#home-about")?.scrollIntoView({ behavior: "smooth" })}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-white/60 hover:text-white transition-colors bg-transparent border-none cursor-pointer"
        aria-label="Scroll down"
        style={{ animation: "fade-in-up 1s ease-out 1s forwards", opacity: 0 }}
      >
        <ArrowDown className="w-6 h-6 animate-bounce" />
      </button>
    </section>
  );
}
